/**
 * Utility functions for Shadcn/ui
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes with proper precedence
 *
 * Usage:
 *   cn("px-4 py-2", isActive && "bg-blue-500")
 *   cn("text-lg", className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
